<template>
    <div v-for="(acessorio, id) in selecionados" :key="id" class="flex flex-col gap-2 mt-3">
        <h3 class="">{{ acessorio.item }}</h3>
        <div class="flex justify-between">
            <div class="botao-icone" :class="acessorio.estado === 'quebrado' ? 'botao-selecionado quebrado' : ''"
                :id="id" @click="selecionarEstado(id, 'quebrado')">
                <img class="w-8 h-8" src="@/assets/quebrado.png" alt="Imagem automovel tombado">
            </div>

            <div class="botao-icone" :class="acessorio.estado === 'ausente' ? 'botao-selecionado ausente' : ''"
                :id="id" @click="selecionarEstado(id, 'ausente')">
                <span class="material-symbols-outlined">remove</span>
            </div>
            <div class="botao-icone" :class="acessorio.estado === 'bom' ? 'botao-selecionado bom' : ''"
                :id="id" @click="selecionarEstado(id, 'bom')">
                <span class="material-symbols-outlined">thumb_up</span>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import ComponentesService from '@/services/ComponentesService';

export default defineComponent({
    name: 'ItensAcessorio',
    props: {
        acessoriosEquipamentos: {
            type: Array,
            required: true
        },
        etapa: {
            type: Number,
            required: true
        },
        idComponente: {
            type: String,
            required: true
        },
        modulo: {
            type: String,
            required: true
        }
    },
    emits: ['aoSelecionarEstado'],
    methods: {
        selecionarEstado(id, estado) {
            this.selecionados[id].estado = estado;
            ComponentesService.salvarRespostaEstadoComponente(this.modulo, this.etapa, this.idComponente, this.selecionados)
            this.$emit('aoSelecionarEstado')
        }
    },
    setup(props) {
        const selecionados = ref(props.acessoriosEquipamentos)
        return { selecionados }
    }
});
</script>

<style scoped>
.ausente {
    @apply bg-[#6e5dc633] border-[#917bff] text-[#917bff] hover:ring-[#917bff];
}

.quebrado {
    @apply bg-[#f08f92] border-[#CC0003] hover:ring-vermelho-padrao;
}

.bom {
    @apply bg-[#c3f5cd] border-verde-sucesso hover:ring-verde-sucesso;
}
</style>